module.exports = __webpack_public_path__ + "img/elvis-frog-promo_pt.95b1cf29.jpg";